<div class="total-change">
    <app-main-table
        [tableConfig]="tableConfig"
        class="total-charge-table"
        (sendInfoToComponent)="clickColum($event)"
    ></app-main-table>
</div>
